import * as React from 'react';
import { useState } from 'react';
import { format } from 'date-fns';

import t from './locales';
import Button from '../Shared/Button';
import { IPeople } from './types';

interface IProps {
  itemId: number;
  people: IPeople;
  payableDateList?: Date[];
  validate: () => boolean;
  timeSchedule?: string
}

const SnowItemPurchaseButton: React.FC<IProps> = (props) => {
  const { itemId, payableDateList, people, validate, timeSchedule } = props;
  const { adultNum, childNum } = people;
  const [isLoading, toggleLoading] = useState(false);

  const handleClick= (event: React.MouseEvent): void => {
    event.preventDefault();

    if (isLoading) { return; }
    if (!validate()) { return; }
    toggleLoading(true);

    const firstDateString = format(payableDateList[0], 'yyyy-MM-dd');
    const query = [
      `order[adult_num]=${adultNum}`,
      `order[child_num]=${childNum}`,
      `order[scheduled_date]=${firstDateString}`,
      `order[time_schedule]=${timeSchedule}`,
    ];
    location.href = `/snow/items/${itemId}/orders/new?${query.join('&')}`;
  }

  return (
    <Button href="#" onClick={handleClick} isLoading={isLoading} snowItemButton={true}>
      {t.purchase()}
    </Button>
  );
}

export default SnowItemPurchaseButton;
